class globalShare {
  isBack!: boolean;
  isDestroy!: boolean;
  transitionCode: string = "";
  // isBack!: boolean;
}
export default new globalShare();
